import React from "react";
import { Outlet } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminSidebar from "./AdminSidebar";


/**
 * ============================================================
 * ADMIN LAYOUT SHELL (AUTHENTICATED CONSOLE)
 * ============================================================
 * Persistent shell for all authenticated admin pages:
 * - Fixed Admin Top Header with breadcrumb & user profile
 * - Persistent desktop Sidebar navigation
 * - Responsive mobile drawer navigation (Sheet in AdminHeader)
 * - Isolated from consumer SiteLayout, mega nav, footer, and chat.
 */
export default function AdminLayout() {
  React.useEffect(() => {
    document.documentElement.classList.add("admin-theme");
    return () => {
      document.documentElement.classList.remove("admin-theme");
    };
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 flex flex-col selection:bg-primary/20 selection:text-slate-900">
      {/* Background ambient lighting */}
      <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden bg-slate-50">
        <div className="absolute inset-0 opacity-[0.03] [background-image:repeating-linear-gradient(0deg,transparent,transparent_7.5%,rgba(0,0,0,0.8)_calc(7.5%+1px)),repeating-linear-gradient(90deg,transparent,transparent_7.5%,rgba(0,0,0,0.8)_calc(7.5%+1px))]" />
        <div className="absolute inset-0 bg-[radial-gradient(900px_450px_at_50%_-10%,rgba(0,194,255,0.07),transparent_60%)]" />
      </div>

      {/* Top Header */}
      <AdminHeader />

      {/* Body: Desktop Sidebar + Page Content */}
      <div className="flex-1 flex min-h-0">
        {/* Desktop Sidebar (Persistent) */}
        <div className="hidden lg:block w-64 flex-shrink-0 sticky top-16 h-[calc(100vh-4rem)] overflow-y-auto overflow-x-hidden admin-scrollbar">
          <AdminSidebar />
        </div>

        {/* Dynamic Page Content */}
        <main className="flex-1 min-w-0 p-6 sm:p-8 md:p-10 max-w-7xl mx-auto w-full">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
